<template>
  <v-row no-gutters>
    <v-col cols="12" :class="$vuetify.breakpoint.mdAndDown ? 'px-3' : 'px-5'">
      <v-form ref="editTelegramForm">
        <app-form-field
          :enabledLabel="true"
          v-model.trim="telegramInfo.telegram"
          :label="$t(`field.telegram`)"
          :placeholder="$t(`fieldHint.fillUpHere`)"
          :rules="validator.telegramRules()"
        ></app-form-field>
        <v-row no-gutters class="pb-10">
          <v-col cols="12">
            <app-button class="dialog-button" :action="this.submit" :title="$t(`button.submit`)"></app-button>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { formValidator, errorCodeHelper, locale } from '@/util'
import { MEMBER_UPDATE_DETAIL } from '@/store/member.module'

export default {
  name: 'profileEditTelegram',
  mounted() {
    this.$refs.editTelegramForm.reset()
  },
  props: {
    closeAction: {
      type: Function,
      required: true,
      default: () => {}
    },
    personalInfo: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    validator: formValidator,
    telegramInfo: {
      telegram: ''
    }
  }),
  created() {
    this.telegramInfo.telegram = this.personalInfo.telegram?.value || ''
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    updateDetailResponseComplete() {
      return this.$store.state.member.updateDetailResponse.complete
    }
  },
  watch: {
    updateDetailResponseComplete() {
      let response = this.$store.state.member.updateDetailResponse
      if (response.complete) {
        if (response.code !== 0 && !response.success) {
          this.$parent.$parent.openAlert(false, errorCodeHelper.getErrorCodeDesc(response.code))
        } else {
          this.$parent.$parent.openAlert(true, locale.getMessage(`message.memberPersonalDetailUpdated`))
          this.closeAction()
        }
      }
    }
  },
  methods: {
    submit() {
      if (this.$refs.editTelegramForm.validate()) {
        let memberObj = {
          telegram: this.telegramInfo.telegram
        }
        this.$store.dispatch(`${MEMBER_UPDATE_DETAIL}`, { memberObj })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-button {
  width: 100%;
  text-transform: capitalize;
  border-radius: 10px;
}
</style>
